import resources from '@/store/modules/resources.js'

export default function(error) {
  if (error.message === 'Network Error') {
    // eslint-disable-next-line no-console
    console.error(JSON.stringify(error))
  }

  if (!error.response) {
    error.response = {
      status: 500,
      data: {
        message: resources.state.resources.general.errors.response500,
      },
    }
  }

  return error
}
